import { client } from '@/services/v2/client'
import { useQuery } from '@tanstack/react-query'
import { ProfileQueryKeys } from 'containers/profile/types/query-keys'
import { useUser } from 'containers/user/hooks/useUser'
import { User } from 'containers/user/types/user'

const BASE_URL = '/api/v1/users/connections/mutual'

interface MutualConnectionsParams {
  userId?: string
  connectionId: string
  skip?: number
  limit?: number
}

export const useMutualConnections = ({
  userId,
  connectionId,
  skip = 0,
  limit = 2,
}: Partial<MutualConnectionsParams>) => {
  const { user } = useUser()

  const usingUserId = userId || user?.id

  let cleanedConnectionId = connectionId
  if (typeof connectionId === 'string' && connectionId.includes('people/c')) {
    cleanedConnectionId = 'ColdProfile'
  }
  const { data, ...rest } = useQuery({
    queryKey: [
      ProfileQueryKeys.MUTUAL_CONNECTIONS,
      { userId: usingUserId, passedId: cleanedConnectionId, skip, limit },
    ],
    queryFn: () =>
      client<User[]>(
        `${BASE_URL}/userList/${usingUserId}/${cleanedConnectionId}/${skip}/${limit}`
      ),
    enabled: !!usingUserId && !!connectionId,
  })

  return {
    data: data || [],
    ...rest,
  }
}

export const useMutualConnectionsCount = ({
  userId,
  connectionId,
}: Partial<MutualConnectionsParams>) => {
  const { user } = useUser()

  const usingUserId = userId || user?.id

  let cleanedConnectionId = connectionId
  if (typeof connectionId === 'string' && connectionId.includes('people/c')) {
    cleanedConnectionId = 'ColdProfile'
  }

  const { data, ...rest } = useQuery({
    queryKey: [
      ProfileQueryKeys.MUTUAL_CONNECTIONS,
      ProfileQueryKeys.MUTUAL_CONNECTIONS_COUNT,
      { userId: usingUserId, passedId: cleanedConnectionId },
    ],
    queryFn: () =>
      client<number>(`${BASE_URL}/count/${usingUserId}/${cleanedConnectionId}`),
    enabled: !!usingUserId && !!connectionId,
  })

  return {
    count: data,
    ...rest,
  }
}
